import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    IndexTable,
    // Card,
    // IndexFilters,
    // useSetIndexFiltersMode,
    // useIndexResourceState,
    Text,
    useBreakpoints,
    Thumbnail,
    // Badge,
    Button,
    Tooltip,
} from '@shopify/polaris';
import { ExternalSmallIcon } from '@shopify/polaris-icons';
import { useDispatch } from 'react-redux';
import { handleProduct } from '../../redux/product/slice';
import { dynamicResourceName, limit, redirectToAdmin } from '../../utils';

const ProductTable = ({
    products,
    pageInfo,
    totalProductsCount,
    onPaginationChange,
    isProductLoading,
    // handleFiltersQueryChange,
    // handleQueryValueRemove,
    // searchValue,
    selectedResources,
    allResourcesSelected,
    handleSelectionChange,
    collectionId
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const [selected, setSelected] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    // const [sortSelected, setSortSelected] = useState(['date asc']);
    // const sortOptions = [
    //     { label: 'Date', value: 'date asc', directionLabel: 'Ascending' },
    //     { label: 'Date', value: 'date desc', directionLabel: 'Descending' }
    // ];
    // const { mode, setMode } = useSetIndexFiltersMode();

    const handleNavigate = (id, title, image, status, variantCount) => {
        navigate(`/configure-products/${id.split('/').pop()}`);
        dispatch(handleProduct({
            title: title,
            image: image,
            status: status,
            variantCount: variantCount
        }));
    }

    const handleNext = useCallback(() => {
        if (pageInfo.hasNextPage && onPaginationChange) {
            setCurrentPage(prev => prev + 1);
            onPaginationChange({
                after: pageInfo.endCursor,
                before: null,
                query: `collection_id:${collectionId}`
            });
        }
    }, [pageInfo, onPaginationChange, collectionId]);

    const handlePrevious = useCallback(() => {
        if (pageInfo.hasPreviousPage && onPaginationChange) {
            setCurrentPage(prev => prev - 1);
            onPaginationChange({
                after: null,
                before: pageInfo.startCursor,
                query: `collection_id:${collectionId}`
            });
        }
    }, [pageInfo, onPaginationChange, collectionId]);

    const rowMarkup = products.map(
        (
            { id, title, status, image, variantCount },
            index,
        ) => {
            return (
                <IndexTable.Row
                    id={id}
                    key={id}
                    selected={selectedResources.includes(id)}
                    position={index}
                >
                    <IndexTable.Cell>
                        <Thumbnail size="small" source={image} />
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div
                            // onClick={() => handleNavigate(id, title, image, status, variantCount)}
                            style={{ cursor: 'pointer' }}
                        >
                            <Text variant="bodyMd" fontWeight="bold" as="span">
                                {id.split('/').pop()}
                            </Text>
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {title}
                    </IndexTable.Cell>
                    {/* <IndexTable.Cell>
                        <Badge tone={status === 'ACTIVE' ? 'success' : 'info'}>
                            {status}
                        </Badge>
                    </IndexTable.Cell> */}
                    <IndexTable.Cell>{variantCount} variants</IndexTable.Cell>
                    <IndexTable.Cell>
                        <Tooltip content='View product'>
                            <Button
                                onClick={() => redirectToAdmin('products', id.split('/').pop())}
                                icon={ExternalSmallIcon}
                                variant='secondary'
                            ></Button>
                        </Tooltip>
                    </IndexTable.Cell>
                </IndexTable.Row>
            );
        }
    );

    return (
        <React.Fragment>
            {/* <Card padding='0' roundedAbove='sm'> */}
            {/* <IndexFilters
                // sortOptions={sortOptions}
                // sortSelected={sortSelected}
                queryValue={searchValue}
                queryPlaceholder="Searching in all"
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={handleQueryValueRemove}
                // onSort={setSortSelected}
                cancelAction={{
                    onAction: handleQueryValueRemove,
                    disabled: false,
                    loading: false,
                }}
                tabs={[]}
                selected={selected}
                onSelect={setSelected}
                canCreateNewView={false}
                onCreateNewView={() => { }}
                filters={[]}
                appliedFilters={[]}
                onClearAll={handleQueryValueRemove}
                mode={mode}
                setMode={setMode}
            /> */}
            <div className='table'>
                <IndexTable
                    condensed={useBreakpoints().smDown}
                    resourceName={dynamicResourceName('product')}
                    itemCount={products.length}
                    selectedItemsCount={
                        allResourcesSelected ? 'All' : selectedResources.length
                    }
                    // onSelectionChange={handleSelectionChange}
                    onSelectionChange={(selectionType, toggleType, selection) => {
                        if (selectedResources?.length > 0 && selection !== selectedResources[0]) return;
                        handleSelectionChange(selectionType, toggleType, selection);
                    }}
                    selectable={true}
                    loading={isProductLoading}
                    headings={[
                        { title: 'Image' },
                        { title: 'ID' },
                        { title: 'Title' },
                        // { title: 'Status' },
                        { title: 'Variant count' },
                        { title: 'Action' }
                    ]}
                    pagination={{
                        hasNext: currentPage < totalProductsCount / limit,
                        onNext: handleNext,
                        label: `${(currentPage - 1) * limit + 1}–${Math.min(
                            currentPage * limit,
                            totalProductsCount
                        )} of ${totalProductsCount} products`,
                        hasPrevious: currentPage > 1,
                        onPrevious: handlePrevious,
                    }}
                >
                    {rowMarkup}
                </IndexTable>
            </div>
            {/* </Card> */}
        </React.Fragment>
    );
};

export default ProductTable;